module.exports = __webpack_public_path__ + "static/img/RAPDS_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPDS_1.png
// module id = +kBh
// module chunks = 0